<template>
    <bottom-sheet v-model="shows" title="로그인" maxWidth="424" fullscreen persistent>
        <template #activator="{ attrs, on }">
            <slot name="activator" v-bind="{ attrs, on }" />
        </template>
        <v-layout column justify-center class="bottom-sheet__contents">
            <v-img src="/images/ci.svg" contain class="mh-40px mh-lg-60px w-100 mb-30 mb-lg-100"></v-img>
            <login-card v-on="{ loggedIn }" />
        </v-layout>
    </bottom-sheet>
</template>

<script>
import LoginCard from "@/components/client/login/login-card.vue";
import BottomSheet from "@/components/dumb/bottom-sheet.vue";
export default {
    components: {
        LoginCard,
        BottomSheet,
    },
    data: () => ({
        shows: false,
    }),
    methods: {
        close() {
            this.shows = false;
        },
        loggedIn() {
            alert("로그인 되었습니다");
            this.close();
        },
    },
};
</script>

<style>
</style>